import { render, staticRenderFns } from "./welfare-center.vue?vue&type=template&id=386a6761&scoped=true&lang=pug&"
import script from "./welfare-center.vue?vue&type=script&lang=js&"
export * from "./welfare-center.vue?vue&type=script&lang=js&"
import style0 from "./welfare-center.vue?vue&type=style&index=0&id=386a6761&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386a6761",
  null
  
)

export default component.exports